module.exports = __webpack_public_path__ + "img/IMG_0045-1200w.f54bf423.jpg";